interface Props{
    action:any;
    setResponse:any;
}
export const ProxyForms=({action,setResponse}:Props)=>{
    return(
        <p>Custon Forms {action.FormCode}</p>
    )
}